import React from "react";
import { Card, CardBody, Col, Modal, Row } from "react-bootstrap";
import RenderFields from "./RenderFields";
import { handlePurchaseReqTableDataCreateUpdate } from "./commonHandlerFunction/Purchase/PurchaseReq/PurchaseReqTableHandler";
import { decryptDataForURL } from "../../utills/useCryptoUtils";
import {
  getCalculationsForPrice,
  getPendingQty,
} from "./commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";
import purchainform from "../../formJsonData/Purchase/PurchaseRequsition/PurchaseRequsitionForm.json";
import { getCurrentRole } from "../../services/commonFunction";
const PopUpPurchaseReq = ({
  popupAddPurchaseReq,
  setPopupAddPurchaseReq,
  formData,
  handleFieldChange,
  formErrors,
  tab,
  sectionIndex,
  handleSubmit,
  setIsOverlayLoader,
  navigate,
  setFormData,
  editableIndex,
  setEditableIndex,
  setTableData,
  moduleType,
  tableData,
  isProdRecv,
}) => {
  const tabDetails =
    moduleType == "purchase" && editableIndex === ""
      ? purchainform.sections[1]?.["tabs"]?.[0]
      : tab;
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const isInsurance = decryptDataForURL(params.get("isInsurance"));

  const cancelFormData = () => {
    let item = tableData[editableIndex];
    let updatedFormData = { ...formData };
    const i = editableIndex;
    updatedFormData["prd_id_" + i] = item?.prd_id;
    updatedFormData["prd_item_code_" + i] = item?.fk_item_id;
    updatedFormData["prd_item_code_text_" + i] =
      item?.item_details?.item_rm_code;
    updatedFormData["prd_item_description_" + i] = item?.prd_item_description;
    updatedFormData["prd_quantity_" + i] = item?.prd_quantity;
    updatedFormData["prd_uom_" + i] = item?.prd_uom;
    updatedFormData["prd_manufacture_time_" + i] = item?.prd_manufacture_time;
    updatedFormData["prd_make_" + i] = item?.prd_make;
    updatedFormData["prd_tech_specification_" + i] =
      item?.prd_tech_specification;
    updatedFormData["prd_avg_monthly_consumption_" + i] =
      item?.prd_avg_monthly_consumption;
    updatedFormData["prd_buffer_stock_" + i] = item?.prd_buffer_stock;
    updatedFormData["prd_closing_stock_" + i] = item?.prd_closing_stock;
    updatedFormData["prd_consumption_per_day_" + i] =
      item?.prd_consumption_per_day;
    updatedFormData["prd_available_stock_days_" + i] =
      item?.prd_available_stock_days;
    updatedFormData["prd_requested_delivery_date_" + i] =
      item?.prd_requested_delivery_date;
    updatedFormData["prd_remark_" + i] = item?.prd_remark;
    updatedFormData["prd_unit_price_" + i] = item?.prd_unit_price;
    updatedFormData["prd_price_" + i] = item?.prd_price;
    updatedFormData["prd_discount_" + i] = item?.prd_discount;
    updatedFormData["prd_total_" + i] = item?.prd_total;
    updatedFormData["prd_miscellaneous_items_" + i] =
      item?.prd_miscellaneous_item;
    updatedFormData["prd_additional_remark_" + i] = item?.prd_additional_remark;
    updatedFormData["prd_specification_" + i] = item?.prd_item_specifications;
    let prd_insurance_json = {};
    if (item?.prd_insurance_json) {
      prd_insurance_json = Object.fromEntries(
        Object.entries(item?.prd_insurance_json).map(([key, value]) => [
          `${key}_${i}`,
          value,
        ]),
      );
    }

    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        1: {
          ...prevFormData[1],
          ...updatedFormData,
          ...prd_insurance_json,
        },
      };
    });
    setPopupAddPurchaseReq(false);
    setEditableIndex("");
  };
  const getGSTCondition = (field) => {
    if (["prd_gst_18", "prd_gst_28"].includes(field.name)) {
      const key18 =
        editableIndex !== "" ? `prd_gst_18_${editableIndex}` : "prd_gst_18";
      const key28 =
        editableIndex !== "" ? `prd_gst_28_${editableIndex}` : "prd_gst_28";

      let val18 = formData[1]?.[key18] || null;
      let val28 = formData[1]?.[key28] || null;

      // store original type (important)
      if (!field.originalType) {
        field.originalType = field.type;
      }

      // both empty → normal input
      if (!val18 && !val28) {
        field.type = field.originalType;
      }

      // if 18 has value → make 28 label
      else if (val18) {
        if (field.name === "prd_gst_28") {
          field.type = "label";
          field.defaultValue = null;
        } else {
          field.type = field.originalType;
        }
      }

      // if 28 has value → make 18 label
      else if (val28) {
        if (field.name === "prd_gst_18") {
          field.type = "label";
          field.defaultValue = null;
        } else {
          field.type = field.originalType;
        }
      }
    }

    return field;
  };

  return (
    popupAddPurchaseReq && (
      <div className="popupSearchContainerBG">
        <div className="popupPurchaseModal">
          <Row className="autoWidthImportant">
            <span className="purchaseModalHeader">Add Purchase Requistion</span>
          </Row>
          <div className="my-2 bg-white purchaseMainDiv">
            <Card className="CardbodyPurchasePopUp">
              <CardBody>
                <Row className="autoWidthImportant ">
                  {tabDetails?.headers?.map((field, fieldIndex) => {
                    let viewOnlyField = false;
                    if (isInsurance) {
                      viewOnlyField = !field.isInsuranceField;
                    }
                    if (isProdRecv) {
                      viewOnlyField = ![
                        "prd_item_status",
                        "prd_received_quantity",
                        "prd_date_of_receipt",
                        "prd_expiry_date",
                        "prd_remark",
                        "prd_is_pre_closed",
                      ].includes(field.name);
                    }
                    if (
                      field.isInsuranceField &&
                      (moduleType === "purchaseReq" ||
                        !["Approved", "Closed"].includes(
                          formData?.[0]?.po_status,
                        ))
                    ) {
                      return null;
                    }
                    if (
                      [
                        "prd_item_status",
                        "prd_received_quantity",
                        "prd_date_of_receipt",
                        "prd_expiry_date",
                        "prd_remark",
                        "prd_is_pre_closed",
                      ].includes(field.name)
                    ) {
                      // return null
                      if (!isProdRecv) {
                        if (!(['SU'].includes(getCurrentRole()) && field.name == 'prd_remark')) {
                          viewOnlyField = true;
                          field.isDisabledField = true;
                        }
                      } else {
                        // field.isDisabledField=false
                      }
                    } else if (
                      ["prd_gst_18", "prd_gst_28"].includes(field.name)
                    ) {
                      field = getGSTCondition(field);
                    }
                    if (field.name == "prd_price") {
                      field.defaultValue = getCalculationsForPrice(
                        formData[1],
                        editableIndex,
                      );
                    }
                    if (field.name === "prd_pending_quantity") {
                      field.defaultValue = getPendingQty(
                        formData[1]?.["prd_quantity_" + editableIndex],
                        formData[1]?.["prd_received_quantity_" + editableIndex],
                      );
                    }
                    if (!isProdRecv) {
                      if (field.isProdRecv) {
                        if (!(['SU'].includes(getCurrentRole()) && field.name == 'prd_remark')) {
                          return null;
                        }
                      }
                    }
                    if (editableIndex === "") {
                      viewOnlyField = false;
                    }
                    if (['prd_buffer_stock', 'prd_closing_stock', 'prd_closing_stock', 'prd_avg_monthly_consumption', 'prd_available_stock_days', 'prd_consumption_per_day'].includes(field.name)) {
                      // if (formData[1]?.['is_stock_field_edit' + (editableIndex !== "" ? '_' + editableIndex : '')]){
                      viewOnlyField = true
                      // }
                    }
                    return (
                      <div
                        className={"col-md-" + (field.width || 6)}
                        key={"Headers-" + fieldIndex}
                      >
                        <RenderFields
                          field={{
                            ...field,
                            required:
                              [
                                "prd_tech_specification",
                                "prd_specification",
                                "prd_item_status",
                                "prd_received_quantity",
                                "prd_date_of_receipt",
                                "prd_pending_quantity",
                                "prd_expiry_date",
                                "prd_remark",
                                "prd_additional_remark"
                              ].includes(field.name) || field.isInsuranceField
                                ? false
                                : true,
                            type:
                              field.isInsuranceField ||
                                [
                                  "prd_item_status",
                                  "prd_received_quantity",
                                  "prd_date_of_receipt",
                                  "prd_expiry_date",
                                  "prd_remark",
                                  "prd_is_pre_closed",
                                ].includes(field.name)
                                ? field.type
                                : field.name === "prd_requested_delivery_date"
                                  ? "date"
                                  : field.name === "prd_item_code" &&
                                    (moduleType === "purchaseReq" || editableIndex === "")
                                    ? "DropDownWithLoadMore"
                                    : [
                                      "prd_item_description",
                                      "prd_tech_specification",
                                      "prd_uom",
                                      "prd_item_code_text",
                                      "prd_miscellaneous_items",
                                      "prd_specification",
                                      "prd_additional_remark",
                                      "prd_manufacture_time",
                                      "prd_make",
                                    ].includes(field.name)
                                      ? "text"
                                      : "number",
                            readOnly: viewOnlyField
                              ? true
                              : moduleType === "purchaseReq"
                                ? ["prd_item_description", "prd_uom"].includes(
                                  field.name,
                                )
                                : moduleType === "purchase"
                                  ? [
                                    "prd_item_code_text",
                                    "prd_item_description",
                                    "prd_uom",
                                    "prd_manufacture_time",
                                    "prd_price",
                                    "prd_total",
                                  ].includes(field.name)
                                  : false,
                            // maxLength: field.name === "prd_remark" ? 200 : undefined,
                            tooltip:
                              field.name === "prd_remark"
                                ? "Character limit 200"
                                : `Enter ${field.label}`,
                            name:
                              field.isInsuranceField && field.type === "label"
                                ? field.name
                                : editableIndex !== ""
                                  ? field.name + "_" + editableIndex
                                  : field.name,
                          }}
                          required={true}
                          // type={field.name === "prd_requested_delivery_date" ? "date" : field.name === "prd_item_code" ? "DropDownWithLoadMore" : field.name === "prd_tech_specification" ? "text" : "number"}
                          sectionIndex={sectionIndex}
                          fieldIndex={fieldIndex}
                          formData={formData}
                          handleFieldChange={handleFieldChange}
                          formErrors={formErrors}
                          upperClass="popupPurchaseUpperClass"
                          customName={
                            field.isInsuranceField && field.type === "label"
                              ? field.name
                              : editableIndex !== ""
                                ? field.name + "_" + editableIndex
                                : field.name
                          }
                        />
                      </div>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
            <div className="purchasePopupButtonRow">
              <button
                onClick={() => {
                  cancelFormData();
                }}
                className="cancelPurchaseBtn"
              >
                Cancel
              </button>
              <button
                className="submitPurchaseBtn"
                onClick={(e) => {
                  handlePurchaseReqTableDataCreateUpdate(
                    formData,
                    handleSubmit,
                    setIsOverlayLoader,
                    navigate,
                    "status",
                    setPopupAddPurchaseReq,
                    setFormData,
                    editableIndex,
                    editableIndex !== "",
                    setEditableIndex,
                    setTableData,
                    tabDetails,
                    moduleType === "purchase" ? "purchase" : "",
                    isProdRecv,
                  );
                }}
                type="button"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default PopUpPurchaseReq;
